import { render, staticRenderFns } from "./distcommission.vue?vue&type=template&id=0f48aa25&"
import script from "./distcommission.vue?vue&type=script&lang=js&"
export * from "./distcommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports